import { render, staticRenderFns } from "./food-tag-manage-modal.vue?vue&type=template&id=432978c6&"
import script from "./food-tag-manage-modal.vue?vue&type=script&lang=js&"
export * from "./food-tag-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports